/**
 * v-reveal — anima o elemento quando ele entra na viewport.
 * Uso: <div v-reveal> ou <div v-reveal="120"> (delay em ms)
 */
const observers = new WeakMap();

export default {
  inserted(el, binding) {
    el.classList.add("reveal");

    const delay = Number(binding.value) || 0;
    if (delay) el.style.transitionDelay = `${delay}ms`;

    if (typeof IntersectionObserver === "undefined") {
      el.classList.add("is-visible");
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );

    observer.observe(el);
    observers.set(el, observer);
  },

  unbind(el) {
    const observer = observers.get(el);
    if (observer) {
      observer.disconnect();
      observers.delete(el);
    }
  },
};
